import helpers from '../helpers';
import popup from './popup';
import {Analytics} from './request-simple';
import ssoAuth from './sso-auth';

// const pageClass = document.querySelector('body').classList;
const $form = document.querySelector('#request-infoshop');

let onceShow = true;

const utm = {
	utm_source: '{source}',
	utm_medium: 'cpc',
	utm_content: 'gid|{gbid}|ad_id|{ad_id}|phrase_id|{phrase_id}',
	utm_campaign: '{campaign_id}',
	utm_term: '{keyword}',
};

function getHeight(elem) {
	return Math.max(
		elem.scrollHeight,
		elem.offsetHeight,
		elem.clientHeight,
	);
}

function sendAjaxForm(form, url) {
	const formType = form.dataset.formType
	let isResident = false;
	let dataParams = new FormData();
	let messages = {
		success: '<p>Спасибо, что заполнили форму!</p><p>Мы скоро с вами свяжемся</p>',
		error_message: '<p>Ошибка!</p>',
		error: '<p>Что-то пошло не так!</p><p>Попробуйте повторить</p>',
	};

	for (const pair of new FormData(form)) {

		if (pair[0] === 'phoneNumber') {
			dataParams.append(pair[0], pair[1].replace(/[() -]/g, ''));
		} else if (pair[0] === 'resident') {
			if (document.querySelector('.infoshop-agents')) {
				dataParams.append('agents', 'true');
				isResident = 'agents';
			} else {
				isResident = true;
			}

			dataParams.append(pair[0], pair[1]);
		} else {
			dataParams.append(pair[0], pair[1]);
		}
	}

	for (let i = 0; i < localStorage.length; i++) {
		let key = localStorage.key(i);

		dataParams.append(key, localStorage.getItem(key));
	}

	let request = new XMLHttpRequest();
	request.open('POST', url, true);

	request.addEventListener('load', function () {
		if (this.status >= 200 && this.status < 400) {
			let response = JSON.parse(this.response);
			if (response.status === 'success') {
				form.reset();
				popup.openPopup(messages.success);

				// события аналитики
				Analytics.reachGoal(formType)
			} else {
				popup.openPopup(`${messages.error_message}<p>${response.message}</p>`);
			}
		} else {
			popup.openPopup(messages.error);
		}
	});

	request.addEventListener('error', () => {
		popup.openPopup(messages.error);
	});

	request.send(dataParams);
}

function checkNumber(value) {
	const val = value.replace(/[^+\d]/g, '');

	return val.includes('+7') && val.length >= 12
}

/**
 * Получение GET параметра из url
 * @param string name
 * @return string|null
 */

function getUrlParam(name) {
	let params = [];

	window.location.search.substring(1).split('&').forEach((param) => {
		param = param.split('=');
		if (param[0] && param[1]) {
			params[param[0]] = param[1];
		}
	});

	return typeof params[name] !== 'undefined' ? params[name] : null;
}

const init = () => {

	if ($form) {
		for (let key in utm) {
			if (getUrlParam(key) !== null) {
				localStorage.setItem(key, getUrlParam(key));
			}
		}

		Inputmask({
			mask: '+7 (999) 999-9999',
		}).mask('#phoneResident');

		helpers.$document
			.on('focus', '.form__input', (e) => {
				$(e.currentTarget).addClass('is-active');
				$(e.currentTarget).closest('.form__item').addClass('is-active');
			})
			.on('blur', '.form__input', (e) => {
				if ($(e.currentTarget).val() < 1) {
					$(e.currentTarget).removeClass('is-active');
					$(e.currentTarget).closest('.form__item').removeClass('is-active');
				}
			})
			.on('input', '#phoneResident', (e) => {
				const formGroupMsg = document.querySelector('.form__group--msg');
				if (!formGroupMsg.classList.contains('is-active')) {
					const heightFormGroupMsg = getHeight(formGroupMsg);
					formGroupMsg.style.height = `${heightFormGroupMsg}px`;
					formGroupMsg.classList.add('is-active');
				}
			})

		$.validator.addMethod('validationNumber', function(value, element) {
			if (checkNumber(value) && onceShow) {
				onceShow = false;
			}

			return this.optional(element) || checkNumber(value);
		}, 'Неверно указан телефон');

		$('#request-infoshop').validate({
			rules: {
				Firstname: {
					required: true,
					minlength: 2,
				},
				phoneNumber: {
					required: true,
					validationNumber: true,
				},
			},
			messages: {
				Firstname: {
					required: 'Заполните это поле',
				},
				phoneNumber: {
					required: 'Введите номер телефона',
				},
			},

			submitHandler: (form) => {
				// eslint-disable-next-line consistent-return
				const send = () => {
					const formUrlLead = '/ajax/sendlead.php';
					const formUrl = '/ajax/send.php';

					if (document.querySelector('#request-infoshop').querySelector('input[name="page"]')) {
						if (document.querySelector('#request-infoshop').querySelector('input[name="page"]').value === 'tips' || document.querySelector('#request-infoshop').querySelector('input[name="page"]').value === 'cloud-cheki') {
							sendAjaxForm(form, formUrlLead);

							return false;
						}
					}
					sendAjaxForm(form, formUrl);
				};

				ssoAuth.init(form, send);

				return false;
			},
		});
	}
};

export default {
	init,
};
